class KlaviyoBackInStockCustom extends HTMLElement {
  constructor() {
    super();
    this.ELM_form = this.querySelector('.form-klaviyo-bis');
    this.ELM_errorMessage = this.querySelector('#error_message');
    this.ELM_completedMessage = this.querySelector('#completed_message');

    this.ELM_form.addEventListener('submit', e => {
      e.preventDefault();
      const requestOptions = this.getData();
      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Minknx", requestOptions)
        .then(result => {
          if (result.status === 202) {
            this.ELM_completedMessage.style.display = 'block';
            this.ELM_errorMessage.style.display = 'none';
          } else {
            this.ELM_completedMessage.style.display = 'none';
            this.ELM_errorMessage.innerHTML = error[0]?.detail || 'Please submit again.';
            this.ELM_errorMessage.style.display = 'block';
          }
        })
        .catch(error => {
          this.ELM_completedMessage.style.display = 'none';
          this.ELM_errorMessage.innerHTML = error[0]?.detail || 'Please submit again.';
          this.ELM_errorMessage.style.display = 'block';
        });
    });
  }

  getData() {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                  "email": `${this.querySelector('input').value}`
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${this.querySelector('select').value}`
            }
          }
        }
      }
    };
    return {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-06-15"
      },
      body: JSON.stringify(payload)
    };
  }
}

customElements.define('klaviyo-back-in-stock-custom', KlaviyoBackInStockCustom);
